import React,{useState,useEffect} from 'react';
import AuthorFields from '../components/AuthorFields';
import CitationResult from '../components/CitationResult';
import {formatAuthorsForCitation,formatAuthorsForParenthetical,formatAuthorsForReference,formatURL} from '../utils/citationHelpers';

function MovieForm() {
const [directors,setDirectors]=useState([]);
const [directorType,setDirectorType]=useState('personal');
const [formData,setFormData]=useState({
title: '',
year: '',
mediaType: 'Película',
productionCompany: '',
url: ''
});
const [result,setResult]=useState(null);
const [liveResult,setLiveResult]=useState(null);

const handleInputChange=(e)=> {
setFormData({...formData,[e.target.name]: e.target.value});
};

// Genera una vista previa en tiempo real
useEffect(()=> {
if (directors.length > 0 && formData.title && formData.year) {
generatePreview();
} else {
setLiveResult(null);
}
},[directors,formData]);

const formatDirectorsForReference=(directors,directorType)=> {
if (!directors || directors.length===0) {
return '';
}

const formattedDirectorStrings=directors.map(director=> {
if (director.type==='institutional') {
if (director.abbreviation) {
return `${director.name} [${director.abbreviation}]`;
}
return director.name;
} else { // personal
const initials=director.firstNames
.split(/\s+/)
.map(name=> `${name.charAt(0).toUpperCase()}.`)
.join(' ');
return `${director.lastNames}, ${initials}`;
}
});

let result='';
if (formattedDirectorStrings.length===1) {
result=formattedDirectorStrings[0];
} else {
const lastAuthor=formattedDirectorStrings.pop();
result=`${formattedDirectorStrings.join(', ')}, & ${lastAuthor}`;
}

const lastDirectorInList=directors[directors.length - 1];
if (lastDirectorInList.type==='institutional') {
result +='.';
}

return result;
};

const getDirectorLabel=(directors,directorType)=> {
if (directorType==='institutional') {
return directors.length > 1 ? '(Directores)' : '(Director)';
}
// Para directores personales,determinar el género basado en el último director
if (directors.length===0) return '(Director)';
const lastDirector=directors[directors.length - 1];
const isAllFeminine=directors.every(d=> d.gender==='feminine');
const isAllMasculine=directors.every(d=> d.gender==='masculine');

if (directors.length===1) {
return lastDirector.gender==='feminine' ? '(Directora)' : '(Director)';
} else {
if (isAllFeminine) {
return '(Directoras)';
} else {
return '(Directores)';
}
}
};

const generatePreview=()=> {
// Verificar si hay autores institucionales con siglas
const institutionalAuthors=directors.filter(
author=> author.type==='institutional' && author.abbreviation
);
let narrativeCitation,parentheticalCitation,narrativeSubsequent,parentheticalSubsequent;

if (institutionalAuthors.length===1 && (directorType==='institutional' || directorType==='both')) {
// Para cita narrativa con institucional con sigla: "Nombre (SIGLA,año)"
narrativeCitation=`${institutionalAuthors[0].name} (${institutionalAuthors[0].abbreviation},${formData.year})`;
// Para cita parentética: "(Nombre [SIGLA],año)"
parentheticalCitation=`(${institutionalAuthors[0].name} [${institutionalAuthors[0].abbreviation}],${formData.year})`;
// Para cita narrativa subsecuente: "SIGLA (año)"
narrativeSubsequent=`${institutionalAuthors[0].abbreviation} (${formData.year})`;
// Para cita parentética subsecuente: "(SIGLA,año)"
parentheticalSubsequent=`(${institutionalAuthors[0].abbreviation},${formData.year})`;
} else {
// Caso normal sin autor institucional con sigla o múltiples autores
const directorsForCitation=formatAuthorsForCitation(directors,directorType);
const directorsForParenthetical=formatAuthorsForParenthetical(directors,directorType);
const directorsForCitationSubsequent=formatAuthorsForCitation(directors,directorType,false);
const directorsForParentheticalSubsequent=formatAuthorsForParenthetical(directors,directorType,false);

narrativeCitation=`${directorsForCitation} (${formData.year})`;
parentheticalCitation=`(${directorsForParenthetical},${formData.year})`;
narrativeSubsequent=`${directorsForCitationSubsequent} (${formData.year})`;
parentheticalSubsequent=`(${directorsForParentheticalSubsequent},${formData.year})`;
}

const citation={
narrative: narrativeCitation,
parenthetical: parentheticalCitation,
narrativeSubsequent: narrativeSubsequent,
parentheticalSubsequent: parentheticalSubsequent
};

const directorsForReference=formatDirectorsForReference(directors,directorType);
const directorLabel=getDirectorLabel(directors,directorType);
const url=formatURL(formData.url);

let referenceText=`${directorsForReference} ${directorLabel}. (${formData.year}). <em>${formData.title}</em> [${formData.mediaType}]`;
if (formData.productionCompany) {
referenceText +=`. ${formData.productionCompany}`;
}
if (url) {
referenceText +=`. ${url}`;
} else {
referenceText +='.';
}
const reference={
html: referenceText,
text: referenceText.replace(/<[^>]*>/g,'')
};
setLiveResult({citation,reference});
};

const generateCitation=()=> {
if (directors.length===0 || !formData.title || !formData.year) {
alert('Por favor completa todos los campos obligatorios');
return;
}
// Verificar si hay autores institucionales con siglas
const institutionalAuthors=directors.filter(
author=> author.type==='institutional' && author.abbreviation
);
let narrativeCitation,parentheticalCitation,narrativeSubsequent,parentheticalSubsequent;

if (institutionalAuthors.length===1 && (directorType==='institutional' || directorType==='both')) {
// Para cita narrativa con institucional con sigla: "Nombre (SIGLA,año)"
narrativeCitation=`${institutionalAuthors[0].name} (${institutionalAuthors[0].abbreviation},${formData.year})`;
// Para cita parentética: "(Nombre [SIGLA],año)"
parentheticalCitation=`(${institutionalAuthors[0].name} [${institutionalAuthors[0].abbreviation}],${formData.year})`;
// Para cita narrativa subsecuente: "SIGLA (año)"
narrativeSubsequent=`${institutionalAuthors[0].abbreviation} (${formData.year})`;
// Para cita parentética subsecuente: "(SIGLA,año)"
parentheticalSubsequent=`(${institutionalAuthors[0].abbreviation},${formData.year})`;
} else {
// Caso normal sin autor institucional con sigla o múltiples autores
const directorsForCitation=formatAuthorsForCitation(directors,directorType);
const directorsForParenthetical=formatAuthorsForParenthetical(directors,directorType);
const directorsForCitationSubsequent=formatAuthorsForCitation(directors,directorType,false);
const directorsForParentheticalSubsequent=formatAuthorsForParenthetical(directors,directorType,false);

narrativeCitation=`${directorsForCitation} (${formData.year})`;
parentheticalCitation=`(${directorsForParenthetical},${formData.year})`;
narrativeSubsequent=`${directorsForCitationSubsequent} (${formData.year})`;
parentheticalSubsequent=`(${directorsForParentheticalSubsequent},${formData.year})`;
}

const citation={
narrative: narrativeCitation,
parenthetical: parentheticalCitation,
narrativeSubsequent: narrativeSubsequent,
parentheticalSubsequent: parentheticalSubsequent
};

const directorsForReference=formatDirectorsForReference(directors,directorType);
const directorLabel=getDirectorLabel(directors,directorType);
const url=formatURL(formData.url);

let referenceText=`${directorsForReference} ${directorLabel}. (${formData.year}). <em>${formData.title}</em> [${formData.mediaType}]`;
if (formData.productionCompany) {
referenceText +=`. ${formData.productionCompany}`;
}
if (url) {
referenceText +=`. ${url}`;
} else {
referenceText +='.';
}
const reference={
html: referenceText,
text: referenceText.replace(/<[^>]*>/g,'')
};
setResult({citation,reference});
};

return (
<div className="max-w-4xl mx-auto">
<div className="mb-8">
<h1 className="text-3xl font-bold text-gray-900 mb-2 dark:text-gray-100">Película,documental o video</h1>
<p className="text-gray-600 dark:text-gray-400">Contenido audiovisual</p>
</div>
<div className="grid lg:grid-cols-2 gap-8">
<div className="bg-white rounded-lg border border-gray-200 p-6 space-y-6 dark:bg-gray-800 dark:border-gray-700">
<AuthorFields
authors={directors}
setAuthors={setDirectors}
authorType={directorType}
setAuthorType={setDirectorType}
label="Directores"
showGender={true}
/>
<div>
<label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
Título *
</label>
<input
type="text"
id="title"
name="title"
value={formData.title}
onChange={handleInputChange}
className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
required
/>
</div>
<div className="grid grid-cols-2 gap-4">
<div>
<label htmlFor="year" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
Año de publicación *
</label>
<input
type="number"
id="year"
name="year"
value={formData.year}
onChange={handleInputChange}
className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
required
/>
</div>
<div>
<label htmlFor="mediaType" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
Tipo de medio
</label>
<select
id="mediaType"
name="mediaType"
value={formData.mediaType}
onChange={handleInputChange}
className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
>
<option value="Película">Película</option>
<option value="Documental">Documental</option>
<option value="Video">Video</option>
</select>
</div>
</div>
<div>
<label htmlFor="productionCompany" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
Productora
</label>
<input
type="text"
id="productionCompany"
name="productionCompany"
value={formData.productionCompany}
onChange={handleInputChange}
className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
/>
</div>
<div>
<label htmlFor="url" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
URL
</label>
<input
type="url"
id="url"
name="url"
value={formData.url}
onChange={handleInputChange}
className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
/>
</div>
<button
type="button"
onClick={generateCitation}
className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
>
Generar cita y referencia
</button>
</div>
<div className="space-y-6">
{!result && liveResult && (
<CitationResult
citation={liveResult.citation}
reference={liveResult.reference}
livePreview={true}
/>
)}
<CitationResult
citation={result?.citation}
reference={result?.reference}
/>
</div>
</div>
</div>
);
}

export default MovieForm;